import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11M8.5 10c-.665 0-1.5.717-1.5 2s.835 2 1.5 2c.459 0 .96-.302 1.265-.934l1.801.868C11.006 15.096 9.892 16 8.5 16 6.404 16 5 14.03 5 12s1.404-4 3.5-4c1.392 0 2.507.904 3.066 2.066l-1.801.868C9.46 10.302 8.959 10 8.5 10m6 2c0-1.283.835-2 1.5-2 .459 0 .96.302 1.265.934l1.801-.868C18.506 8.904 17.392 8 16 8c-2.096 0-3.5 1.97-3.5 4s1.404 4 3.5 4c1.392 0 2.506-.904 3.066-2.066l-1.801-.868c-.305.632-.806.934-1.265.934-.665 0-1.5-.717-1.5-2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandCreativeCommons = { render };
export {
  brandCreativeCommons as default,
  render
};
//# sourceMappingURL=brand-creative-commons.svg.js.map
